package com.kinoshazam.screens.details

import androidx.compose.runtime.Composable
import features.watch.model.WatchTarget
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.continue_short
import kinoshazam.resources.generated.resources.next_episode
import kinoshazam.resources.generated.resources.watch
import kinoshazam.resources.generated.resources.watch_again
import org.jetbrains.compose.resources.stringResource

@Composable
fun watchCtaLabel(target: WatchTarget?): String {
    if (target == null) return stringResource(Res.string.watch)
    return when {
        target.completed -> stringResource(Res.string.watch_again)
        target.queuedNext -> stringResource(Res.string.next_episode)
        target.positionSec > 0 -> stringResource(Res.string.continue_short)
        else -> stringResource(Res.string.watch)
    }
}
